document.addEventListener('DOMContentLoaded', () => {
          const locationKey = "userLocation"; // Key for localStorage
          const expirationKey = "locationExpiration"; // Key for expiration timestamp
          const expirationTime = 24 * 60 * 60 * 1000; // 24 hours in milliseconds
          const zipInput = document.getElementById('text-input-zipcode');
          const updateButton = document.getElementById('updateZip');
        
          // Function to update the UI
          function updateLocationUI(location) {
            console.log('Updating location with:', location);
            $('#popup-city').text(location.city ? location.city + ', ' : '');
            $('#popup-state').text(location.region || '');
            $('#popup-zip').text(location.zip || '');
            $('#product-city').text(location.city ? location.city + ', ' : '');
            $('#header-city').text(location.city ? location.city + ', ' : '');
            $('#product-state').text(location.abbreviation || '');
            $('#header-state').text(location.abbreviation || '');
            $('#product-zip').text(location.zip || '');
        
            // Handle visibility of buttons based on state abbreviation
            // if (location.abbreviation !== 'CA') {
              // Hide items > 8 Feet for non-California locations
              $('.Popover__Value').each(function () {
                const valueText = $(this).data('value');
                if (valueText.includes('Feet') && parseFloat(valueText) > 16) {
               //   $(this).hide();
                }
              });
              var id = $('.Select--primary').find('select');
              $(id).find('option').each(function () {
                  const available = $(this).attr('data-available'); // Ensure string comparison for HTML attributes
                  if (available === 'true') {
                      var title = $(this).data('title');
                      var price = $(this).data('price');
                      var variantId = $(this).val(); // Get the selected variant ID
              
                      // Update product details
                      $('.ProductMeta__Price.Price.Text--subdued.u-h4').text(price);
                      $('.ProductForm__SelectedValue').text(title);
                      if ($('#building-template').length == 0) {
                      $('.ProductForm__AddToCart').html('<span>Add to cart</span><span class="Button__SeparatorDot"></span><span>' + price + '</span>');
                      }
                      console.log('Trying to select an available option.');
              
                      // Set the option as selected
                      $(this).prop('selected', true);
              
                      // Trigger the change event on the parent <select> element
                      id.get(0).dispatchEvent(new Event('change'));
              
                      // Update the URL with the selected variant ID
                      const url = new URL(window.location.href);
                      url.searchParams.set('variant', variantId); // Replace the variant ID
                      window.history.replaceState(null, '', url.toString()); // Update the URL without reloading
              
                      return false; // Exit the loop
                  }
              });
              
            
            // } else {
            //   console.log('trying to make ita ll show');
            //   // Show all items for California
            //   $('.Popover__Value').each(function () {
            //     $(this).removeClass('hidden'); // Remove any hidden class
            //     $(this).show(); // Ensure the element is visible
            //     $(this).removeAttr('style'); // Remove inline styles
            //   });
            // }
          }
        
          // Function to check if localStorage data is expired
          function isExpired() {
            try {
              const savedTime = localStorage.getItem(expirationKey);
              return !savedTime || Date.now() - parseInt(savedTime, 10) > expirationTime;
            } catch (e) {
              console.log('localStorage blocked, treating as expired');
              return true;
            }
          }
        
          // Fetch ZIP code based on country, state, and city
          function fetchZipByCity(locationData) {
            const url = `https://api.zippopotam.us/us/${locationData.abbreviation}/${locationData.city}`;
            console.log('Fetching ZIP details from city:', url);
        
            return fetch(url)
              .then((response) => {
                if (!response.ok) {
                  throw new Error(`ZIP lookup error! Status: ${response.status}`);
                }
                return response.json();
              })
              .then((data) => {
                if (data.places && data.places.length > 0) {
                  locationData.zip = data.places[0]["post code"];
                  console.log('ZIP found:', locationData.zip);
        
                  // Save updated location
                  saveLocation(locationData);
                  updateLocationUI(locationData);
                  updateCPLocationUI(locationData);
                }
              })
              .catch((error) => {
                console.error('Failed to fetch ZIP code:', error);
              });
          }
        
          // Fetch location based on ZIP code
          function fetchLocationByZip(zip) {
            const url = `https://api.zippopotam.us/us/${zip}`;
        
            return fetch(url)
              .then((response) => {
                if (!response.ok) {
                  throw new Error(`ZIP lookup error! Status: ${response.status}`);
                }
                return response.json();
              })
              .then((data) => {
                const locationData = {
                  country: "United States",
                  region: data.places[0]["state"],
                  city: data.places[0]["place name"],
                  zip: zip,
                  abbreviation: data.places[0]["state abbreviation"],
                };
        
                saveLocation(locationData);
                updateLocationUI(locationData);
                updateCPLocationUI(locationData);
              })
              .catch((error) => {
                alert('Invalid ZIP code or API error. Please try again.');
                console.error('Error fetching location by ZIP:', error);
              });
          }
        
          // Fetch location based on IP
          function fetchLocationByIP() {
            const url = `https://get.geojs.io/v1/ip/geo.json`;
        
            return fetch(url)
              .then((response) => {
                if (!response.ok) {
                  throw new Error(`HTTP error! Status: ${response.status}`);
                }
                return response.json();
              })
              .then((data) => {
                const stateAbbreviations = {
                  "Alabama": "AL", "Alaska": "AK", "Arizona": "AZ", "Arkansas": "AR",
                  "California": "CA", "Colorado": "CO", "Connecticut": "CT", "Delaware": "DE",
                  "Florida": "FL", "Georgia": "GA", "Hawaii": "HI", "Idaho": "ID",
                  "Illinois": "IL", "Indiana": "IN", "Iowa": "IA", "Kansas": "KS",
                  "Kentucky": "KY", "Louisiana": "LA", "Maine": "ME", "Maryland": "MD",
                  "Massachusetts": "MA", "Michigan": "MI", "Minnesota": "MN", "Mississippi": "MS",
                  "Missouri": "MO", "Montana": "MT", "Nebraska": "NE", "Nevada": "NV",
                  "New Hampshire": "NH", "New Jersey": "NJ", "New Mexico": "NM", "New York": "NY",
                  "North Carolina": "NC", "North Dakota": "ND", "Ohio": "OH", "Oklahoma": "OK",
                  "Oregon": "OR", "Pennsylvania": "PA", "Rhode Island": "RI", "South Carolina": "SC",
                  "South Dakota": "SD", "Tennessee": "TN", "Texas": "TX", "Utah": "UT",
                  "Vermont": "VT", "Virginia": "VA", "Washington": "WA", "West Virginia": "WV",
                  "Wisconsin": "WI", "Wyoming": "WY",
                };
        
                const locationData = {
                  country: data.country || "United States",
                  region: data.region,
                  city: data.city,
                  zip: data.postal || "",
                  abbreviation: stateAbbreviations[data.region] || data.region_code || "",
                };
        
                if (!locationData.zip) {
                  fetchZipByCity(locationData); // Look up ZIP if not provided
                } else {
                  saveLocation(locationData);
                  updateLocationUI(locationData);
                  updateCPLocationUI(locationData);
                }
              })
              .catch((error) => console.error('Error fetching location by IP:', error));
          }
        
          function saveLocation(locationData) {
            try {
              localStorage.setItem(locationKey, JSON.stringify(locationData));
              localStorage.setItem(expirationKey, Date.now().toString());
            } catch (e) {
              console.log('localStorage blocked, cannot save location');
            }
          }
        
          // Initialize: Check if localStorage has location data and handle accordingly
          try {
            if (!localStorage.getItem(locationKey) || isExpired()) {
              fetchLocationByIP(); // Fetch location using GeoJS
            } else {
              const locationData = JSON.parse(localStorage.getItem(locationKey));
              updateLocationUI(locationData);
              updateCPLocationUI(locationData);
            }
          } catch (e) {
            console.log('localStorage blocked, fetching location by IP');
            fetchLocationByIP();
          }
        
          // Handle manual ZIP code update
          updateButton.addEventListener('click', () => {
            const zip = zipInput.value.trim();
        
            // Validate ZIP code (5 digits)
            if (/^\d{5}$/.test(zip)) {
              fetchLocationByZip(zip); // Fetch new location details based on ZIP
            } else {
              alert('Please enter a valid 5-digit ZIP code.');
            }
          });
          $('body').on('click','.map-header-flex,.blue-location',function() {
                    console.log('clicked');
                    $('.ReactModal__Overlay.Custom-Modal').addClass('ReactModal__Overlay--after-open');
                });
                $('body').on('click','.Modal__close-wrapper, #close-btn-pop',function() {
                 $('.ReactModal__Overlay--after-open').removeClass('ReactModal__Overlay--after-open');
                });
function normalizeCardHeights() {
  const cards = document.querySelectorAll('.jdgm-carousel--card-theme .jdgm-carousel-item');
  let maxHeight = 0;

  // Reset heights
  cards.forEach(card => {
    card.style.height = 'auto';
  });

  // Find the tallest card
  cards.forEach(card => {
    const height = card.offsetHeight;
    if (height > maxHeight) {
      maxHeight = height;
    }
  });

  // Set all cards to the tallest height
  cards.forEach(card => {
    card.style.height = maxHeight + 'px';
  });
}

window.addEventListener('load', normalizeCardHeights);
window.addEventListener('resize', normalizeCardHeights);

if ($('#building-template').length > 0) {
    console.log('Titan garage script: DOM Content Loaded');
    
    // Function to wait for jQuery to be available
    function waitForJQuery(callback) {
        if (typeof $ !== 'undefined' && $ && $.ajax) {
            console.log('Titan garage: jQuery is available');
            callback();
        } else {
            console.log('Titan garage: Waiting for jQuery...');
            setTimeout(function() {
                waitForJQuery(callback);
            }, 100);
        }
    }

    // Handle the add-to-cart button click
$('body').on('click','.Drawer__Close',function(e) {
                $('#sidebar-cart').attr('aria-hidden','true');
              $('.PageOverlay').removeClass('is-visible');
});
  // Show the loading overlay
function showLoadingOverlay() {
    document.getElementById('loadingOverlay').style.display = 'flex';
}

// Hide the loading overlay
function hideLoadingOverlay() {
    document.getElementById('loadingOverlay').style.display = 'none';
}
/*
$('body').on('click', '#trigger-ATC', function(e) {
    // we meed tp ,a
    e.preventDefault();
    showLoadingOverlay();
    // Check if the terms checkbox is checked
    if (!$('#termsCheckbox').is(':checked')) {
        hideLoadingOverlay();
        alert('Please accept the terms and conditions before adding the product to the cart.');
        return; // Exit the function if terms are not accepted
    }

    // Check if pickup option is selected
    if ($('#pickupCheckbox').is(':checked')) {
        // If pickup is selected, add the item to the Shopify cart
        var pickUpVariant = $('#pick-up-price').data('pickup-variant');
        $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            dataType: 'json',
            data: {
                id: pickUpVariant, // Variant ID for pickup option
                quantity: 1
            },
            success: function(response) {
                // Optionally, redirect to the cart page
                    setTimeout(function() {
                document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
  bubbles: true
}));
              $('.zdrawer-close').trigger('click');
              $('#sidebar-cart').attr('aria-hidden','false');
              $('.PageOverlay').addClass('is-visible');
                    },500);
            },
            error: function(error) {
                hideLoadingOverlay();
                alert('Failed to add item to cart.');
                console.error(error);
            }
        });
    } else {
        // If pickup is not selected, send data to the PHP program

        // Get compare-at price, price, and location from the page
        const compareAtPrice = $('.ProductMeta__Price.Price.Price--compareAt').text().replace('$', '').trim();
        let priceText = $('.ProductMeta__Price.Price.Price--highlight').text().trim();

// If primary price is missing or empty, use the fallback
if (!priceText) {
    priceText = $('.ProductMeta__Price.Price.Text--subdued.u-h4').text().trim();
}

const price = priceText.replace('$', '').replace(',', '');
        const locationText = $('#pricing-location').text().split('Pricing is based on your location of ')[1].split('.')[0]; // Extract city and state
        const product_id = $('#building-template').data('product-id');
      //  alert('my product id is ' + product_id);
        // Prepare data to send to PHP program
        const postData = {
            product_id: product_id,
            compare_price: compareAtPrice,
            price: price,
            city_state: locationText
        };
      console.log(postData)
        // Make POST request to the PHP program
$.ajax({
    type: 'POST',
    url: 'https://dekstechdevops.com/steeldash_variant_create_V3.php',
    data: postData,
    success: function(response) {
        // Parse the response (assuming it's in JSON format)
        console.log(response);
        var parsedResponse = response;
        console.log('my parsed response is ', parsedResponse);

        // Check if the variant is returned in the response
        if (parsedResponse.variant && parsedResponse.variant.id) {
            // Get the variant ID from the response
            var newVariantId = parsedResponse.variant.id;
            console.log('my variant id is ' + newVariantId);

            // Function to attempt adding the variant to the cart
            function tryAddToCart() {
                $.ajax({
                    type: 'POST',
                    url: '/cart/add.js',
                    dataType: 'json',
                    data: {
                        id: newVariantId,  // Use the variant ID from the response
                        quantity: 1        // Set quantity to 1
                    },
                    success: function(cartResponse) {
                        console.log('Cart response:', cartResponse);
                        // Optionally, redirect to the cart page
                        window.location.href = '/checkout';
                    },
                    error: function(cartError) {
                        console.error('Cart error:', cartError);
                        // Retry after a short delay
                        setTimeout(tryAddToCart, 1000);  // Retry after 2 seconds
                    }
                });
            }

            // Initial attempt to add to cart with retry logic
            setTimeout(tryAddToCart, 1000); // First attempt after 1.5 seconds
        } else {
            hideLoadingOverlay();
            console.log('Failed to retrieve variant ID from server response.');
        }
    },
    error: function(xhr, status, error) {
        hideLoadingOverlay();
        alert('Failed to send data to the server.');
        console.error('Error:', error);
    }
});


    }
});
*/
$('.ProductForm__AddToCart').removeAttr('disabled');
    document.querySelector('.ProductForm__AddToCart').addEventListener('click', function(event) {
        event.preventDefault(); // Prevent the form from submitting
        event.stopPropagation(); // Prevent the document click handler from firing
        event.stopImmediatePropagation();
        const snowload = sessionStorage.getItem('selectedSnowload');
          if (!snowload) {
    alert('You must choose your snowload before configuring your building.');
    $('.snow-loads').trigger('click');
    return; // do nothing
  }
  else {
        // Open the drawer
        document.querySelector('.zdrawer').classList.add('open');
        
        // Enable outside click handler after a short delay
        setTimeout(function() {
            zdrawerOutsideClickEnabled = true;
        }, 100);
    }
    });

    // Handle drawer close button
    document.querySelector('.zdrawer-close').addEventListener('click', function() {
        document.querySelector('.zdrawer').classList.remove('open');
        zdrawerOutsideClickEnabled = false;
    });

    // Variable to control zdrawer outside click handler
    let zdrawerOutsideClickEnabled = false;

    // Close the zdrawer when clicking outside the drawer content
    window.addEventListener('click', function(event) {
        // Only process if the outside click handler is enabled
        console.log('i clicked and enabled is ' + zdrawerOutsideClickEnabled);
        if (!zdrawerOutsideClickEnabled) return;
        
        const zdrawer = document.querySelector('.zdrawer');
        const zdrawerContent = zdrawer ? zdrawer.querySelector('.zdrawer-content') : null;
        
        // Check if the zdrawer is open
        if (zdrawer && zdrawer.classList.contains('open')) {
            // Close if clicking directly on the zdrawer overlay background
            if (event.target === zdrawer) {
                zdrawer.classList.remove('open');
                zdrawerOutsideClickEnabled = false;
            }
            // Or if clicking outside the zdrawer content
            else if (!zdrawerContent || !zdrawerContent.contains(event.target)) {
                zdrawer.classList.remove('open');
                zdrawerOutsideClickEnabled = false;
            }
        }
    });
    // Origin ZIP code for distance calculations
    const originZip = '92821';  // Origin ZIP code

    // Handle ZIP code submission manually
    const zipcodeSubmitBtn = document.getElementById('zipcodeSubmit');
    const zipcodeInputField = document.getElementById('zipcodeInput');
    
    if (zipcodeSubmitBtn && zipcodeInputField) {
        zipcodeSubmitBtn.addEventListener('click', function() {
            const enteredZip = zipcodeInputField.value;
            console.log('Titan garage: ZIP code submission - entered:', enteredZip);
            
            if (!enteredZip || isNaN(enteredZip) || enteredZip.length !== 5) {
                alert('Please enter a valid 5-digit ZIP code.');
                return;
            }
            // Send the ZIP codes to the server and calculate the price based on the returned distance
            console.log('Titan garage: Calling sendToZapier with origin:', originZip, 'destination:', enteredZip);
            sendToZapier(originZip, enteredZip);
            fetchLocationByZip(enteredZip); // Fetch new location details based on ZIP
        });
    } else {
        console.log('Titan garage: ZIP code submit button or input field not found');
    }
    // Function to get user's ZIP code using IP geolocation
function getUserZipCodeFromIP() {
              // Function to check if localStorage data is expired
          function isExpired() {
            try {
              const savedTime = localStorage.getItem(expirationKey);
              return !savedTime || Date.now() - parseInt(savedTime, 10) > expirationTime;
            } catch (e) {
              console.log('localStorage blocked, treating as expired');
              return true;
            }
          }
          
    const locationKey = "userLocation"; // Key for localStorage
    const expirationKey = "locationExpiration"; // Key for expiration timestamp
    if (localStorage.getItem(locationKey)) {
    console.log(JSON.parse(localStorage.getItem(locationKey)));
    }
    return new Promise((resolve, reject) => {

        // If popup ZIP already exists, return it immediately
        if (!localStorage.getItem(locationKey) || isExpired()) {

        // Otherwise fetch ZIP based on IP
        const url = 'https://ipinfo.io?token=e0f92d83aaef77';

        fetch(url)
            .then(response => response.json())
            .then(data => {
                console.log(data);
                if (data && data.postal) {
                    resolve(data.postal);
                } else {
                    reject(new Error("Unable to determine ZIP code from IP"));
                }
            })
            .catch(error => reject(error));
        }
        else {
            var storedLocation = JSON.parse(localStorage.getItem(locationKey));
            resolve(storedLocation.zip);
            return;
        }
    });
}

 // Function to send ZIP codes to the server and receive the distance
    function sendToZapier(originZipV2, destinationZip) {
      /*
      
        console.log('Titan garage: sendToZapier called with origin:', originZipV2, 'destination:', destinationZip);
        
        $.ajax({
            url: 'https://dekstechdevops.com/steeldash_distance.php',
            type: 'POST',
            data: {
                origin_zip: originZipV2,
                destination_zip: destinationZip
            },
            success: function(response) {
                console.log('Titan garage: Data successfully sent to the server:', response);

                // If the response is already an object, no need to parse it
                const data = response;  

                // Extract the distance in text and value (convert meters to miles)
                console.log('responce',response);
                const distanceText = data.rows[0].elements[0].distance.text; // Extract distance text
                const distanceValue = data.rows[0].elements[0].distance.value / 1609.34; // Convert meters to miles
              // Extract city and state from the Google response
                const city = data.destination_addresses[0].split(',')[0]; // Get the city
                const state = data.destination_addresses[0].split(',')[1].trim().split(' ')[0]; // Get the state

                // Calculate price based on the distance
                const basePrice = $('#pick-up-price').text().replace('$','').replace(',','');
                console.log('Titan garage: Base price extracted:', basePrice);
                
                const calculatedPrice = calculatePrice(distanceValue, basePrice);
                console.log('Titan garage: Calculated price:', calculatedPrice);
                
                // Format the price to include commas
                const formattedPrice = `$${calculatedPrice.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

                // Update the main price on the page
let primaryPriceEl = document.querySelector(
    '.ProductMeta__Price.Price.Price--highlight'
);

// If primary price does NOT exist, use the fallback element
if (!primaryPriceEl) {
    primaryPriceEl = document.querySelector(
        '.ProductMeta__Price.Price.Text--subdued.u-h4'
    );
}

// Update the element if found
if (primaryPriceEl) {
    primaryPriceEl.textContent = formattedPrice;
}

                // Calculate the compare-at price (30% higher) and format it
                const compareAtPrice = (calculatedPrice * 1.3).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
                const formattedCompareAtPrice = `$${compareAtPrice}`;

                // Update the compare-at price on the page
                const compareAtElement = document.querySelector('.ProductMeta__Price.Price.Price--compareAt');
                if (compareAtElement) {
                    compareAtElement.textContent = formattedCompareAtPrice;
                }
                console.log('compare',compareAtElement);

                // Display the price result in the zdrawer
                const priceResultElement = document.getElementById('priceResult');
                if (priceResultElement) {
                    console.log('Titan garage: Updating priceResult to:', `Price: ${formattedPrice}`);
                    priceResultElement.textContent = `Price: ${formattedPrice}`;
                } else {
                    console.log('Titan garage: priceResult element not found');
                }

                // Update the location in the <p id="pricing-location">
                const locationText = `Pricing is based on your location of ${city}, ${state} ${destinationZip}.<br/> <a href="#" id="changeLocation"><span>Click here</span> to change your location</a>`;
                const shortedLocText = `Pricing is based on your location of ${city}, ${state} ${destinationZip}.`;

                
                const pricingLocation = document.getElementById('pricing-location');
                if (pricingLocation) {
                    pricingLocation.innerHTML = locationText;
                }
                
                const pricingLocation2 = document.getElementById('pricing-location2');
                if (pricingLocation2) {
                    pricingLocation2.innerHTML = shortedLocText;
                }
                
                // Handle "Click here to change your location" link click
                const changeLocationLink = document.getElementById('changeLocation');
                if (changeLocationLink) {
                    changeLocationLink.addEventListener('click', function(event) {
                        event.preventDefault();
                        // Open the drawer and focus on the ZIP code input
                        document.querySelector('.zdrawer').classList.add('open');
                        document.getElementById('zipcodeInput').focus();
                        setTimeout(function() {
                            zdrawerOutsideClickEnabled = true;
                        },100)

                    });
                }
            },
            error: function(xhr, status, error) {
                console.error('Titan garage: Error sending data to the server:', error);
                console.log('Titan garage: Raw response:', xhr.responseText);
                alert('Failed to calculate pricing. Please try again.');
            }
        });
        */
    }

    // Function to calculate price based on distance
    function calculatePrice(distance, basePrice) {
        let finalPrice = parseFloat(basePrice);  // Ensure it's parsed as float
        console.log('Titan garage: Base price:', finalPrice);
        console.log('Titan garage: Distance:', distance);
        
        if (distance <= 50) {
            finalPrice -= 250; // Discount for the first 50 miles
        } else {
            finalPrice -= 250; // Discount for the first 50 miles
            console.log('Titan garage: Adding cost for distance over 50 miles. Distance:', distance);
            finalPrice += (distance - 50) * 4; // $4 per mile after the first 50 miles
        }
        return finalPrice;
    }

    setTimeout(function() {
        // Initialize pricing after jQuery is available
        waitForJQuery(function() {
            // Automatically fetch user's ZIP code from IP and calculate distance/price
            getUserZipCodeFromIP().then(zipCode => {
                console.log('Titan garage: Auto-detected ZIP code:', zipCode);
                const zipcodeInputField = document.getElementById('zipcodeInput');
                if (zipcodeInputField) {
                    zipcodeInputField.value = zipCode; // Set ZIP code in input
                }
                sendToZapier(originZip, zipCode); // Calculate and display distance and price
            }).catch(error => {
                console.error("Titan garage: Unable to retrieve ZIP Code:", error.message);
            });
        });
    }, 500);

    (function () {
  // helper: element is visibly rendered
  function isVisible(el) {
    if (!el) return false;
    const cs = getComputedStyle(el);
    return cs.display !== 'none' && cs.visibility !== 'hidden' && el.offsetParent !== null;
  }

  // event delegation on the whole document (works for dynamically loaded items)
  document.addEventListener('click', function (e) {
    const item = e.target.closest('.related-product-item');
    if (!item) return;

    let snowText = null;

    // SCENARIO A: clicked the selected card AND its .related-title.snowload is showing
    if (item.classList.contains('selected')) {
      const snowEl = item.querySelector('.related-title.snowload');
      if (snowEl && isVisible(snowEl)) {
        snowText = snowEl.textContent.trim();
      }
    }

    // SCENARIO B: clicked an item that itself has class .snowload (related snowload option)
    if (!snowText && item.classList.contains('snowload')) {
      // On these cards, the snowload text may not carry the `.snowload` class on <p>,
      // so fall back to any .related-title inside the card.
      const snowEl = item.querySelector('.related-title.snowload') || item.querySelector('.related-title');
      if (snowEl && isVisible(snowEl)) {
        snowText = snowEl.textContent.trim();
      }
    }

    if (snowText) {
      sessionStorage.setItem('selectedSnowload', snowText);
      console.log('[Snowload] stored:', snowText);
    } else {
      console.log('[Snowload] not stored — conditions not met');
    }
  });
})();
}

        });

// Function to update Collection Page Price UI
function updateCPLocationUI(location) {
  const $utility_ProductItems = $('.utility_building_productItem');

  if ($utility_ProductItems.length > 0) {
    console.log('CP Updating location with:', location);

    // Handle visibility of buttons based on state abbreviation
    if (location.abbreviation !== 'CA') {
      $utility_ProductItems.each(function () {
        const $item = $(this);
        const $select = $item.find('.ProductItem__Option select');

        $select.find('option').each(function () {
          const available = $(this).attr('data-available'); // string
          if (available === 'true') {
            const title = $(this).data('title');
            const price = $(this).data('price');

            // Update product details
            const prices = `
              <span class="ProductItem__Price Price Price--highlight Text--subdued">${price}</span>
              <span class="ProductItem__Price Price Price--compareAt Text--subdued">${price}</span>
            `;
            $item.find('.cp_ProductItem__Price').html(prices);

            console.log('Trying to select an available option.');

            return false; // Exit loop for this product item
          }
        });
      });
    } else {
      console.log('Trying to make it all show');
    }
  } else {
    return;
  }
}